import styled from 'styled-components';
import { Col } from '../../../../components/common/Grid';
import { toRem } from '../../../../utils/helpers';

export const PatientCol = styled(Col)`
  min-width: ${toRem(500)}rem;
`;
